import { publicStylesHref } from '@/lib/styles/generated/asset-urls'

// This resource is intentionally not a CSS import: Next must not merge or
// preload the complete public stylesheet into the article's critical path.
export const PublicStyles = () => <link rel="stylesheet" href={publicStylesHref} precedence="ht-public" />
